export default __webpack_public_path__ + "static/media/stocking.ebf30c02.jpg";